
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"vuesax/twotone/notification-status"}},[_c('path',{attrs:{"d":"M31.667 2.083a6.25 6.25 0 11-6.25 6.25 6.257 6.257 0 016.25-6.25zm0 10a3.75 3.75 0 10-3.75-3.75 3.754 3.754 0 003.75 3.75z","fill":"#f29030"}}),_c('path',{attrs:{"data-name":"Vector","d":"M20 22.917h-8.333a1.25 1.25 0 010-2.5H20a1.25 1.25 0 010 2.5zM26.667 29.583h-15a1.25 1.25 0 010-2.5h15a1.25 1.25 0 010 2.5z","fill":"#f29030"}}),_c('path',{attrs:{"data-name":"Vector","d":"M25 37.916H15c-4.617 0-7.745-.977-9.842-3.074S2.083 29.617 2.083 25V15c0-4.617.977-7.745 3.074-9.842S10.382 2.083 15 2.083h8.333a1.25 1.25 0 010 2.5H15c-3.911 0-6.476.744-8.074 2.342S4.583 11.089 4.583 15v10c0 3.911.744 6.476 2.342 8.074s4.164 2.342 8.074 2.342h10c3.911 0 6.476-.744 8.074-2.342S35.415 28.91 35.415 25v-8.334a1.25 1.25 0 112.5 0v8.333c0 4.617-.977 7.745-3.074 9.842S29.617 37.916 25 37.916z","fill":"#245389"}})])])
          )
        }
      }
    